export const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export const hasHardwareKeyboard = () => {
  // Multiple detection methods for better accuracy

  // Method 1: Check if device supports hover (typically desktop/laptop)
  const hasHover = window.matchMedia("(hover: hover)").matches;

  // Method 2: Check pointer type (fine = mouse, coarse = touch)
  const hasFinePointer = window.matchMedia("(pointer: fine)").matches;

  // Method 3: Check screen size (larger screens usually have keyboards)
  const hasLargeScreen = window.matchMedia("(min-width: 1024px)").matches;

  // Method 4: Check for touch capability
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // Method 5: Check orientation lock capability (mobile devices)
  const canLockOrientation =
    "orientation" in window.screen || "mozOrientation" in window.screen;

  // Method 6: Check user agent for desktop indicators
  const userAgent = navigator.userAgent.toLowerCase();
  const isDesktopUA =
    !/(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i.test(
      userAgent
    );

  // Scoring system - each positive indicator adds points
  let score = 0;

  if (hasHover) score += 2;
  if (hasFinePointer) score += 2;
  if (hasLargeScreen) score += 1;
  if (!isTouchDevice) score += 2;
  if (!canLockOrientation) score += 1;
  if (isDesktopUA) score += 1;

  // Return true if score suggests hardware keyboard (threshold of 4 or more)
  return score >= 4;
};

export const getDeviceType = () => {
  const hasKeyboard = hasHardwareKeyboard();
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isLargeScreen = window.matchMedia("(min-width: 1024px)").matches;

  if (hasKeyboard && !isTouchDevice) {
    return "desktop";
  } else if (hasKeyboard && isTouchDevice && isLargeScreen) {
    return "laptop"; // Could be laptop with touchscreen
  } else if (!hasKeyboard && isTouchDevice && isLargeScreen) {
    return "tablet";
  } else if (!hasKeyboard && isTouchDevice) {
    return "mobile";
  } else {
    return "unknown";
  }
};

export const isKeyboardSuitableDevice = () => {
  const deviceType = getDeviceType();
  return deviceType === "desktop" || deviceType === "laptop";
};

export const isChrome = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /chrome/.test(userAgent) && !/edge/.test(userAgent);
};

export const isNativePlatform = () => {
  try {
    const { Capacitor } = require("@capacitor/core");
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const shouldUseRedirect = () => {
  return isIOS() || isNativePlatform();
};
